var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app"}},[_c('app-loading',{attrs:{"active":_vm.loading,"loader":'spinner',"color":'#343a40'}}),(_vm.isOn && !_vm.printing)?_c('m-header'):_vm._e(),_c('router-view'),(_vm.isOn && _vm.routeChat && !_vm.printing)?_c('m-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }